import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CampaignDto } from "../../../models/campaign/dto/campaign.dto";
import { UpdateCampaignInputDto } from "../../../models/campaign/dto/campaign-input.dto";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_CAMPAIGN_QUERY_KEY } from "./useGetCampaign";
import { GET_CAMPAIGNS_QUERY_KEY } from "./useListCampaigns";

export const useUpdateCampaign = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: ({ id, input }: { id: string; input: UpdateCampaignInputDto }) =>
            client.fetchApi<CampaignDto, UpdateCampaignInputDto>({
                endpoint: `campaigns/admin/${id}`,
                method: 'PATCH',
                body: input,
            }),
        onSuccess: (data) => {
            queryClient.setQueryData(GET_CAMPAIGN_QUERY_KEY(data.id), data);
            queryClient.invalidateQueries({ queryKey: GET_CAMPAIGNS_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
